/**
 * THE phone field. One implementation shared by the order details screen and
 * anywhere else a cell number is collected, so the US formatting and the fixed
 * "+1" prefix cannot drift between surfaces.
 *
 * The value handed back to the host is the FORMATTED string; every call site
 * already reduces it to bare digits before it is stored or submitted.
 */
import { cn } from "@/lib/utils";
import { Field, inputClass } from "@/components/consumer/chrome";
import { formatUsPhone, US_DIAL_PREFIX } from "@/lib/phone";

export default function PhoneField({
  value,
  onChange,
  label,
  hint,
  error,
  placeholder,
  className,
  autoFocus,
  testId = "phone-field",
}: {
  value: string;
  onChange: (next: string) => void;
  label: string;
  hint?: string;
  error?: string;
  placeholder?: string;
  className?: string;
  autoFocus?: boolean;
  testId?: string;
}) {
  return (
    <Field label={label} hint={hint} error={error} className={className}>
      <div className="flex gap-2">
        <span
          className="grid h-[52px] flex-none place-items-center rounded-[14px] border border-foreground/[0.18] bg-foreground/[0.04] px-3.5 text-[17px] font-medium text-foreground/70"
          data-testid={`${testId}-prefix`}
        >
          {US_DIAL_PREFIX}
        </span>
        <input
          value={formatUsPhone(value)}
          onChange={(e) => onChange(formatUsPhone(e.target.value))}
          type="tel"
          inputMode="tel"
          autoComplete="tel-national"
          autoFocus={autoFocus}
          placeholder={placeholder}
          className={cn(inputClass, "flex-1")}
          data-testid={testId}
        />
      </div>
    </Field>
  );
}
